export default "__VITE_ASSET__BJDES02s__"